import React from "react";
import { useNavigate } from "react-router-dom";

export default function UpdateComplete({ id }) {
  const navi = useNavigate();
  //styled
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Product Updated</p>
        </div>
        <p>The product has been updated successfully.</p>

        <div className="send-modal-footer">
          <button
            className="pointer cancelButton fw-bold mx-2 px-3"
            onClick={() => navi(`/myoneclub/${id}/PaymentOptions`)}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
